export function canShowTweaks(isDev: boolean, enabled?: string): boolean {
  return isDev && enabled === 'true'
}
